import React, { FC } from 'react';

import { Box, Flex, Skeleton, SkeletonCircle, VStack } from '@bonusly/design-system';

const CelebratinItemSkeleton: FC = () => {
	return (
		<Flex alignItems="center" gap={2} justifyContent="space-between" mb={2}>
			<SkeletonCircle height={10} width={10} flexShrink={0} />
			<VStack spacing={1} alignItems="left" overflow="hidden" flexGrow={1}>
				<Skeleton height={4} width="25%" />
				<Skeleton height={3.5} width="40%" />
			</VStack>
			<Skeleton height={6} width={24} />
		</Flex>
	);
};

export const ModalLoadingState = (): React.ReactElement => {
	return (
		<Box mt={4} data-testid="modal-loading-state">
			<CelebratinItemSkeleton />
			<CelebratinItemSkeleton />
			<CelebratinItemSkeleton />
		</Box>
	);
};
